import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import cx from 'classnames';
import LoadingScreen from '../containers/LoadingScreen';
import Device from '../containers/Device';
import PreviewScreen from '../containers/PreviewScreen';
import CurrentScreen from '../containers/CurrentScreen';
import PreviousScreen from '../containers/PreviousScreen';
import StatusBarUnderlay from '../containers/StatusBarUnderlay';
import EmptyProject from './EmptyProject';
import TouchIndicator from '../containers/TouchIndicator';
import styles from './Player.module.css';
import Cursor from '../containers/Cursor';
export default function Player(_a) {
    var _b;
    var isPlaying = _a.isPlaying, isInHandoffMode = _a.isInHandoffMode, areInitialScreensPreloaded = _a.areInitialScreensPreloaded, areHotspotsLoaded = _a.areHotspotsLoaded, transition = _a.transition, backgroundColor = _a.backgroundColor, isEmpty = _a.isEmpty;
    if (isEmpty) {
        return (React.createElement(Device, null,
            React.createElement(EmptyProject, null)));
    }
    var className = cx(styles.player, styles[transition], (_b = {},
        _b[styles.handoffMode] = isInHandoffMode,
        _b));
    var style = isInHandoffMode
        ? undefined
        : { backgroundColor: "#" + backgroundColor };
    return (React.createElement(Fragment, null,
        React.createElement(TouchIndicator, null),
        React.createElement(Device, null,
            React.createElement("div", null,
                React.createElement("div", { className: className, style: style },
                    !isInHandoffMode && React.createElement(StatusBarUnderlay, null),
                    isPlaying && areInitialScreensPreloaded && areHotspotsLoaded ? (React.createElement("div", null,
                        React.createElement(PreviousScreen, { key: "previous" }),
                        React.createElement(CurrentScreen, { key: "current" }))) : (React.createElement(PreviewScreen, null)),
                    React.createElement(Cursor, null)),
                React.createElement(LoadingScreen, null)))));
}
Player.propTypes = {
    isPlaying: PropTypes.bool.isRequired,
    isInHandoffMode: PropTypes.bool.isRequired,
    areInitialScreensPreloaded: PropTypes.bool.isRequired,
    areHotspotsLoaded: PropTypes.bool.isRequired,
    transition: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    isEmpty: PropTypes.bool.isRequired,
};
